import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AccountService } from "../../../api/services";
import { GlobalApp } from "../../../tools/global";
import { HttpClient } from "@angular/common/http";
import { RegisterDialogComponent } from "../../../dialogs/register-dialog/register-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { DialogResultType } from "../../../dialogs/DialogResult";
import { RegisterLocal } from "../../../api/models";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { MustMatch } from "../../../tools/validators/mustmatch.validator";

@Component({
  selector: "account-register",
  templateUrl: "./account-register.component.html",
})
export class AccountRegisterComponent implements OnInit {
  registerForm: UntypedFormGroup;
  private authWindow: Window;
  failed: boolean;
  error: string;
  errorDescription: string;
  isRequesting: boolean;
  authProvider: string;
  validFromUrl: string;
  submitted = false;

  showCompleteMessage: boolean = false;

  handleMessageMethod: any = null;

  emailAddress: string;
  confirmEmailAddress: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  title: string;
  organization: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  errorMessage: string;

  doneRegistering: boolean = false;

  constructor(
    public accountService: AccountService,
    public snackBar: MatSnackBar,
    public globalApp: GlobalApp,
    private http: HttpClient,
    private dialog: MatDialog,
    private router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    /*this.handleMessageMethod = this.handleMessage.bind(this);

    if (window.addEventListener) {
      window.addEventListener("message", this.handleMessageMethod, false);
    } else {
      (<any>window).attachEvent("onmessage", this.handleMessageMethod);
    }*/

    this.http
      .get<string>("api/Config/GetValidFromUrl")
      .subscribe((urlResult) => {
        this.validFromUrl = urlResult;
      });
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group(
      {
        emailAddress: ["", [Validators.email, Validators.required]],
        confirmEmailAddress: ["", [Validators.email, Validators.required]],
        password: ["", Validators.required],
        confirmPassword: ["", Validators.required],
        firstName: ["", Validators.required],
        lastName: ["", Validators.required],
        title: [""],
        organization: ["", Validators.required],
        address1: ["", Validators.required],
        address2: [""],
        city: ["", Validators.required],
        state: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(2),
          ],
        ],
        zip: ["", Validators.required],
        phone: ["", Validators.required],
      },
      {
        validator: [
          MustMatch("emailAddress", "confirmEmailAddress"),
          MustMatch("password", "confirmPassword"),
        ],
      }
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  onSubmit() {
    this.errorMessage = "";
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }

    var registerLocalParams: RegisterLocal = {
      emailAddress: this.emailAddress,
      password: this.password,
      firstName: this.firstName,
      lastName: this.lastName,
      title: this.title,
      organization: this.organization,
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      state: this.state,
      zip: this.zip,
      phone: this.phone,
    };

    this.accountService.accountRegisterLocal(registerLocalParams).subscribe(
      (result) => {
        this.doneRegistering = true;
      },
      (error) => {
        this.errorMessage = error.error;
      }
    );
  }

  ngOnDestroy() {
    /*if (window.addEventListener) {
      window.removeEventListener("message", this.handleMessageMethod);
    } else {
      (<any>window).detachEvent('onmessage', this.handleMessageMethod);
    }*/
  }

  /*completeRegistration() {
    if (this.emailAddress !== this.confirmEmailAddress) {
      this.errorMessage = "Email addresses do not match";
    } else if (this.password !== this.confirmPassword) {
      this.errorMessage = "Passwords do not match";
    } else {
      var registerLocalParams: RegisterLocal = {
        emailAddress: this.emailAddress,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName,
        title: this.title,
        organization: this.organization,
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        state: this.state,
        zip: this.zip,
        phone: this.phone
      };

      this.accountService.accountRegisterLocal(registerLocalParams).subscribe(result => {
        this.router.navigate(['/login']);
      }, error => {
          this.errorMessage = error.error;
      });
    }
  }*/
}
